import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  notificationTypesLength: 0,
  notificationTypes: [],
  notificationType: {},
  notificationTypeError: "",
  formError: "",
};

export default function NotificationTypeReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_NOTIFICATION_TYPE:      
      return { ...state, loading: action.payload };

    case actions.LOADING_NOTIFICATION_TYPE_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_NOTIFICATION_TYPE:
      return { ...state, saveLoading: action.payload };

    case actions.GET_NOTIFICATION_TYPE:
      return {
        ...state,
        notificationTypes: action.payload.notificationTypes,
        notificationTypesLength: action.payload.notificationTypesLength,
      };

    case actions.GET_NOTIFICATION_TYPE_BY_ID:
      return { ...state, notificationType: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.NOTIFICATION_TYPE_FAIL:
      return { ...state, notificationTypeError: action.payload };

    default:
      return state;
  }
}
